import { Injectable } from '@angular/core';
import { Observable, ReplaySubject, Subject } from 'rxjs';

import { TmsWebBaseService } from '../../base';
import { ProductDesigners, SupplierProductDesigner } from '../../../models';

@Injectable({
  providedIn: 'root',
})
export class ProductDesignerService extends TmsWebBaseService {
  public refreshDetails = new Subject<void>();

  private anyDesignerSuppliers$: ReplaySubject<boolean>;

  constructor() {
    super('ProductDesigner');
  }

  getAllDesignersForProduct(productId: string): Observable<ProductDesigners[]> {
    return this.httpService.get<ProductDesigners[]>(`${this.apiUrl}/GetAllDesigners/${productId}`);
  }

  updateProductDesigners(productId: string, supplierIds: string[]): Observable<void> {
    return this.httpService.post(`${this.apiUrl}/UpdateProductDesigners`, { productId, supplierIds });
  }

  anyDesignerSuppliers(): Observable<boolean> {
    if (!this.anyDesignerSuppliers$) {
      this.anyDesignerSuppliers$ = new ReplaySubject<boolean>(1);
      this.httpService.get<boolean>(`${this.apiUrl}/AnyDesignerSuppliers`).subscribe({
        next: (value) => this.anyDesignerSuppliers$.next(value),
        error: (error) => this.anyDesignerSuppliers$.error(error),
      });
    }
    return this.anyDesignerSuppliers$.asObservable();
  }

  getAllProductsForSupplier(supplierId: string): Observable<SupplierProductDesigner[]> {
    return this.httpService.get<SupplierProductDesigner[]>(`${this.apiUrl}/GetAllProductsForSupplier/${supplierId}`);
  }

  add(productId: string, supplierId: string): Observable<string> {
    return this.httpService.post<string>(`${this.apiUrl}/Add`, { productId, supplierId });
  }

  delete(id: string): Observable<void> {
    return this.httpService.delete<void>(`${this.apiUrl}/${id}`);
  }
}
